import React, { useState, useEffect } from 'react'
import { Box, Container } from '@chakra-ui/react'
import BrandFilter from './brand-filter'
import { BrandItem } from './list-brands'
import { useResponsive } from '@common/hooks'
import { listBrands } from '@lib/util/brand-handler'
import { useQuery } from '@tanstack/react-query'
import { BRAND_LIMIT, AZFilter } from '@constants/brand.constant'
import PaginationLayout from '@layouts/pagination-layout'
import SkeletonBrands from '@components/skeleton/skeleton-brands'
import HeadingTag from '@components/heading-tag'
import AOS from 'aos'
import useAosAnimation from '@common/hooks/use-aos-animation'

export type BrandFilterType = {
  az: AZFilter
}

const Brand = () => {
  const [brands, setBrands] = useState<any[]>([])
  const [page, setPage] = useState(1)
  const [filter, setFilter] = useState<BrandFilterType>({
    az: AZFilter.AZ
  })

  const { xlMax, xlMin } = useResponsive()

  const { data, isLoading } = useQuery(['brands'], () => listBrands())

  useEffect(() => {
    if (data?.data) {
      const pageData = [
        ...data.data.sort((b1: any, b2: any) =>
          b1.title.localeCompare(b2.title)
        )
      ]
      setBrands(pageData)
    }
  }, [data])

  useEffect(() => {
    const { az } = filter

    if (data?.data) {
      const index = (page - 1) * BRAND_LIMIT

      if (az === AZFilter.AZ) {
        const pageData = [
          ...data.data.sort((b1: any, b2: any) =>
            b1.title.localeCompare(b2.title)
          )
        ]
        setBrands(pageData)
      } else if (az === AZFilter.ZA) {
        const pageData = [
          ...data.data.sort((b1: any, b2: any) =>
            b2.title.localeCompare(b1.title)
          )
        ]
        setBrands(pageData)
      }
    }
  }, [filter])

  useAosAnimation({
    duration: 600,
    once: true
  })

  return (
    <Box mt={14} mb={28}>
      <Container>
        <HeadingTag style={{ textAlign: 'center' }} data-aos="fade-down">
          Brands
        </HeadingTag>
        <BrandFilter setFilter={setFilter} filter={filter} />
        {isLoading && <SkeletonBrands />}
        <PaginationLayout
          data={brands || []}
          itemsPerPage={{
            lg: 4,
            md: 3,
            sm: 2,
            base: 2
          }}
          skipPagination={true}
          renderItem={(item: any) => {
            return <BrandItem brand={item} />
          }}
        />
      </Container>
    </Box>
  )
}

export default Brand
